import { TopicStats } from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import { Action } from 'redux';

import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

export interface CounsellingsHomeFetchAction extends Action {
    readonly after: number; // Last item id
}
export const COUNSELLINGS_HOME_FETCH_REQUEST = 'COUNSELLINGS_HOME_FETCH_REQUEST';
export interface CounsellingsHomeFetchRequestAction
    extends CounsellingsHomeFetchAction,
        APIRequestAction {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_REQUEST;
}
export interface CounsellingsHomeFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        posts: number[];
        topics: number[];
        counsellings: number[];
        followingTopics: number[];
    };
}
export const COUNSELLINGS_HOME_FETCH_SUCCESS = 'COUNSELLINGS_HOME_FETCH_SUCCESS';
export interface CounsellingsHomeFetchSuccessAction
    extends CounsellingsHomeFetchAction,
        APISuccessAction<CounsellingsHomeFetchNormalizedResponse> {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
    readonly topicStats: TopicStats;
    readonly lastVisitCounts: TopicStats;
}

export const COUNSELLINGS_HOME_FETCH_FAILURE = 'COUNSELLINGS_HOME_FETCH_FAILURE';
export interface CounsellingsHomeFetchFailureAction
    extends CounsellingsHomeFetchAction,
        APIFailureAction {
    readonly type: typeof COUNSELLINGS_HOME_FETCH_FAILURE;
}

export const counsellingsHomeFetch = {
    request: (after: number): CounsellingsHomeFetchRequestAction => ({
        type: COUNSELLINGS_HOME_FETCH_REQUEST,
        after,
    }),
    success: (
        after: number,
        hasNext: number,
        hasPrevious: number,
        notificationsOn: number[],
        topicStats: TopicStats,
        lastVisitCounts: TopicStats,
        response: CounsellingsHomeFetchNormalizedResponse,
    ): CounsellingsHomeFetchSuccessAction => ({
        type: COUNSELLINGS_HOME_FETCH_SUCCESS,
        after,
        hasNext,
        hasPrevious,
        notificationsOn,
        topicStats,
        lastVisitCounts,
        response,
    }),
    failure: (after: number, error: any): CounsellingsHomeFetchFailureAction => ({
        type: COUNSELLINGS_HOME_FETCH_FAILURE,
        after,
        error,
    }),
};

export const COUNSELLINGS_HOME_LOAD = 'COUNSELLINGS_HOME_LOAD';
export interface CounsellingsHomeLoadAction extends CounsellingsHomeFetchAction {
    readonly type: typeof COUNSELLINGS_HOME_LOAD;
}
export const counsellingsHomeLoad = (after?: number): CounsellingsHomeLoadAction => ({
    type: COUNSELLINGS_HOME_LOAD,
    after,
});
